// eslint-disable-next-line no-restricted-imports -- raw token read kept until this site is moved to theme.semantics
import { DS_COLOR } from '@calm/evexia-design-tokens';
import { Theme } from '@rhg/libs/material';

export const styleSubtitles = (isShowingSubtitles: boolean) => ({
    pb: (theme: Theme) => theme.ds.spacingUnits.SECTION,
    pt: (theme: Theme) =>
        isShowingSubtitles ? 0 : theme.ds.spacingUnits.SECTION,
});

export const styleFloatingSubtitles = {
    background: `linear-gradient(180deg, #00000000 0%, ${DS_COLOR.BLACK_20P} 100%)`,
};

export const styleCenteredSubtitlesWrapper = {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};

export const styleBottomActionsRow = {
    // Keeps the Add to playlist tooltip's containing block fixed while the controls slide in and out, so it never jumps.
    position: 'relative',
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 4,
    mt: 4,
};

export const styleAudioControlsContainer = {
    width: '100%',
};

export const styleFloatingContainer = {
    backgroundColor: 'background.paper',
};

export const styleControlsMain = {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: {
        xs: 'center',
        sm: 'center',
        md: 'center',
        lg: 'space-between',
    },
    alignItems: 'center',
    position: 'relative',
    minHeight: '48px',
};

enum ControlsFlexBasis {
    Large = '42%',
    Medium = '36%',
    Small = '28%',
}

export const styleNonMobileElement = {
    display: { xs: 'none', sm: 'none', md: 'none', lg: 'flex' },
    flexBasis: { lg: ControlsFlexBasis.Large, xl: ControlsFlexBasis.Small },
};

export const styleMetadataContainer = {
    flexBasis: { lg: ControlsFlexBasis.Small, xl: ControlsFlexBasis.Medium },
};

export const styleCustomActionContainer = {
    justifyContent: 'flex-end',
    flexBasis: { lg: ControlsFlexBasis.Small, xl: ControlsFlexBasis.Medium },
};

export const styleControlsCenter = {
    width: '100%',
    position: { xs: 'static', sm: 'static', md: 'static', lg: 'absolute' },
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
};

export const styleControlsButtons = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 4,
};

export const styleControlsButtonsCollapsed = {
    gap: 9,
};

export const styleControlsButtonsTimeline = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'stretch',
    flexGrow: 0,
    flexBasis: {
        md: 'auto',
        lg: ControlsFlexBasis.Large,
        xl: ControlsFlexBasis.Small,
    },
};

export const styleControlsButtonsNoTimeline = {
    mb: 4,
};

export const styleTitleSubtitle = { ml: 4 };

export const styleTitleContainer = {
    display: 'flex',
    alignItems: 'baseline',
    gap: 2,
};

export const styleDrawerTitleIcon = {
    '& svg': {
        height: '16px',
        width: '16px',
    },
};

export const styleMetadata = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
};
